import { createSlice } from '@reduxjs/toolkit';

const StoreSlice = createSlice({
  name: 'storeSlice',
  initialState: {
    all_stores: [],
  },
  reducers: {
    getAllStoresReducer: (state, action) => {
      state.all_stores = action?.payload || [];
    },
  },
});

export default StoreSlice;
